import React, { Fragment, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './CellDocLibraryDocumentsCreatedDates.css';

type CellDocLibraryDocumentsCreatedDatesProps = {
    createdDates: Array<{ createdDate: string }>;
};

const CellDocLibraryDocumentsCreatedDates = ({ createdDates }: CellDocLibraryDocumentsCreatedDatesProps) => {
    const renderCreatedDates = useMemo(() => createdDates.map((item) => (
        <Fragment key={uuidv4()}>
            <div>{item.createdDate}</div>
        </Fragment>
    )), [createdDates]);

    return <div className="CellDocLibraryDocumentsCreatedDates">{renderCreatedDates}</div>;
};

export default CellDocLibraryDocumentsCreatedDates;
